import React, { useContext } from 'react';
import { AccountContext } from '../../Contexts/main.context';

const ClientClientLocations = ({ locations = [] }) => {
     const { updateOriginalID, updateActiveClient, updateActiveOutlet } = useContext(AccountContext);
     const setCurrent = (location) => {
          updateOriginalID(location.ID);
          updateActiveClient(location);
          updateActiveOutlet('Citations');
     };

     return (
          <div className="w-100 alert-light text-center rounded-3 shadow-md">
               <h3 className="py-3">Your locations</h3>
               {locations.length === 0 && <p>No active locations are available for your account.</p>}
               <div className="d-flex p-3 flex-wrap justify-content-center gap-2">
                    {locations.map(location => (
                         <button key={location.ID} type="button" className="location-card p-3 col-48 col-md-22 col-lg-11 mb-3 bg-primary border-0 rounded text-white" onClick={() => setCurrent(location)}>
                              <div className="fw-bold h4 text-white">{location.companyName}</div>
                              <div className="fs-5 fw-bold text-lemon">{location.theLocation}</div>
                              <div>{location.city} {location.postal}</div>
                              <div className="h1 mt-2 text-white">{location.citationCount || 0} <span className="fs-6">Citations</span></div>
                              <div>View citations</div>
                         </button>
                    ))}
               </div>
          </div>
     );
};
export default ClientClientLocations;
